import type { AppContext } from "@/types/scheduling";

export const handleRestartApp = <T extends AppContext>(context: T) => {
  return {
    ...context,
    errorMsg: undefined,
  };
}
